const formatCustomInputValue = (_value, _allowedChars, _notAllowedChars) => {
    const result = _value.replace(_notAllowedChars, "");
    return result;
}

export default formatCustomInputValue;